<template>
    <div class="flex items-center justify-center h-full w-full">
        <USwitch
            :model-value="params.value"
            :disabled="isSystem"
            size="sm"
            @update:model-value="() => params.toggle && params.toggle(params.data)"
        />
    </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue'
import {Dimension} from '@/dimensions/Dimension'
interface USwitchCellRendererParams {
  value: boolean
  data: Dimension
  toggle?: (data: Dimension) => void
}

const props = defineProps<{ params: USwitchCellRendererParams }>()

const isSystem = props.params.data?.type === 'SYSTEM' // Adjust if needed
</script>
